import { render } from "./Malware.vue?vue&type=template&id=48af5047"
import script from "./Malware.vue?vue&type=script&lang=js"
export * from "./Malware.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\cert-v3\\cert\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__